/* jshint esversion: 6 */

import GtmService from '../gtm/gtm.service';

class ContactStoreCtrl {

	constructor(
		$scope,
		$location,
		$timeout,
		$http,
		StateService
	) {
		this.$scope = $scope;
		this.$location = $location;
		this.$timeout = $timeout;
		this.$http = $http;
		this.data = window.data || {};
		this.model = {
			Collections: []
		};
		if (this.$location.search() && this.$location.search().email) {
			this.model.email = this.$location.search().email;
		}
		this.state = StateService.getState();
		this.state.ready();
	}

	onSubmit() {
		console.log('ContactStoreCtrl.onSubmit', this.model);

		var data = this.model;
		data.Collections = data.Collections.join(',');

		var inputCaptcha = document.getElementById('g-recaptcha-response');
		if (inputCaptcha) {
			data.Captcha = inputCaptcha.value;
		} else {
			data.Captcha = '';
		}

		if (this.state.busy()) {
			this.$http.post('/WS/wsUsers.asmx/ContactStore', { data: data }).then(
				success => {
					if (success.data.d.Status) {
						this.state.success();

					//	GtmService.push({ "event": "Action Complete" });
					}
					else {
						this.state.error();
					}
				},
				error => {
					this.error = error;
				}
			);
			this.$timeout(() => {
				// this.state.ready();
			}, 2000);
		}
	}

	onInvalid() {
		console.log(this.model, this);
		this.$scope.$broadcast('onInvalid');
	}

}

ContactStoreCtrl.$inject = ['$scope', '$location', '$timeout', '$http', 'StateService'];

export default ContactStoreCtrl;
